/**
* GENERATED BY RPC GEN - LESS MODIFY BY HAND
* post-service.ts  2023-11-13T18:19:31+08:00
*/
import type { R, RpcService, MethodConfig as M } from 'bt-rpc-base';

import type { ReplyId, TopicId, NewTopic, NewReply } from './discuss-dto';

const _ = 'Post/';

export class PostService {

  constructor(readonly r: RpcService) {}
  // 删除回复
  delReply(d:ReplyId, m?: M): R<boolean>{
    return this.r.async(_ + 'delReply', d, m);
  }
  // 删除主题
  delTopic(d:TopicId, m?: M): R<boolean>{
    return this.r.async(_ + 'delTopic', d, m);
  }
  // 点赞回复
  likeReply(d:ReplyId, m?: M): R<boolean>{
    return this.r.async(_ + 'likeReply', d, m);
  }
  // 点赞主题
  likeTopic(d:TopicId, m?: M): R<boolean>{
    return this.r.async(_ + 'likeTopic', d, m);
  }
  // 发回复,成功返回id，否则报错
  newReply(d:NewReply, m?: M): R<number>{
    return this.r.async(_ + 'newReply', d, m);
  }
  // 发布主题,成功返回id，否则报错
  newTopic(d:NewTopic, m?: M): R<number>{
    return this.r.async(_ + 'newTopic', d, m);
  }
  
  unlikeReply(d:ReplyId, m?: M): R<boolean>{
    return this.r.async(_ + 'unlikeReply', d, m);
  }
  
  unlikeTopic(d:TopicId, m?: M): R<boolean>{
    return this.r.async(_ + 'unlikeTopic', d, m);
  }
}
